export enum OperationType {
  Withdrawal = 'withdrawal',
  Deposit = 'deposit',
  AdminInsuranceDepositBurn = 'admin_insurance_deposit_burn',
}
